import { UrlConfig } from 'config';
import { AjaxService } from 'services';
import { ApiResponse } from 'models/Api/ApiResponse';

export type ExchangeRateMap = Record<string, number>;

type RawExchangeRateLatestResponse = ExchangeRateMap & {
  ok: boolean;
};

export class ExchangeRateApiClient {
  public static async getLatest(): Promise<ExchangeRateMap> {
    const url = UrlConfig.EXCHANGE_RATE.LATEST;
    const response: ApiResponse<RawExchangeRateLatestResponse> = await AjaxService.getData(url, {}, true);
    const { ok: _ok, ...rates } = response.data;
    return rates;
  }
}

